import { Modal } from 'antd'
import React from 'react'
import { MalindexMal } from '../../../api/malindex/malindexApi'
import { MODAL_BREDD, MODAL_GRIND, MODAL_KNAPP, modalTitel } from '../modalStil'

/**
 * NyKartlaggningModal – bekräftelse innan en ny kartläggning startas.
 *
 * En kartläggning startar om från början: allt före den tillhör en tidigare omgång,
 * och de aktiva målen slutar följas upp. Knappen som gör det ligger nedtonad bredvid
 * "Ny uppföljning" och ser oskyldig ut, så konsekvensen måste sägas innan – inte
 * upptäckas efteråt när målen är borta ur översikten.
 *
 * Rutan säger bara två saker: vad som händer i rummet, och vilka mål som inaktiveras.
 * En bekräftelseruta ska bekräfta, inte undervisa – rådet om att ta en uppföljning i
 * stället hör hemma i översikten, hos någon som faktiskt står utan mål.
 *
 * Ingen försäkran om att historiken finns kvar heller. Att skriva "ingenting raderas"
 * lugnar för något ingen fruktade, och planterar därmed oron.
 */

export interface NyKartlaggningModalProps {
  open: boolean
  personnummer: string
  /** Målen som slutar följas upp om kartläggningen startas. */
  aktivaMal: MalindexMal[]
  onBekrafta: () => void
  onAvbryt: () => void
}

const NyKartlaggningModal: React.FC<NyKartlaggningModalProps> = ({
  open,
  personnummer,
  aktivaMal,
  onBekrafta,
  onAvbryt,
}) => {
  const antal = aktivaMal.length

  return (
    <Modal
      open={open}
      {...MODAL_GRIND}
      title={modalTitel('Börja om från början?')}
      okText="Ja, ny kartläggning"
      // Inte röd. Att börja om är ett normalt steg i metoden och raderar ingenting –
      // rött skulle läsa som "farligt" och göra handläggaren osäker på en riktig väg.
      okButtonProps={MODAL_KNAPP}
      onOk={onBekrafta}
      cancelText="Nej, tillbaka"
      cancelButtonProps={MODAL_KNAPP}
      onCancel={onAvbryt}
      width={MODAL_BREDD}
    >
      {/* Vad som händer i rummet, inte vad som händer i databasen. Handläggaren ska
          veta att samtalet blir som det första. */}
      <p className="m-0 text-base text-gray-700">
        Ni går igenom behoven från början, precis som vid det första besöket med{' '}
        <span className="font-medium">{personnummer}</span>.
      </p>

      {antal > 0 && (
        <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50 px-3.5 py-3">
          {/* Rubriken är densamma oavsett antal – "Målet" respektive "Alla 2 mål"
              tvingade fram två varianter, och den ena av dem blev grammatiskt fel. */}
          <p className="m-0 text-base text-gray-700">Följande mål inaktiveras:</p>
          {/* Ingen punktlista och ingen "Mål 1:"-etikett. Målen är hela meningar, och
              rubriken ovanför säger redan vad de är. */}
          <div className="mt-2 flex flex-col gap-1.5">
            {aktivaMal.map((m) => (
              <p key={m.malId} className="m-0 text-base text-gray-800">
                {m.maltext.trim() || m.egnaOrd.trim()}
              </p>
            ))}
          </div>
        </div>
      )}
    </Modal>
  )
}

export default NyKartlaggningModal
